import { render, staticRenderFns } from "./LeadgenUnsubscribe.vue?vue&type=template&id=600b9f2a"
import script from "./LeadgenUnsubscribe.vue?vue&type=script&lang=js"
export * from "./LeadgenUnsubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports